import styled from '@emotion/styled/macro';

import CustomNavLink from '../utils/CustomNavLink';

const ItemLinkWrapper = ({ itemId, url, isMaster, icon, label, onClick }) => {
    return (
        <ItemNavLink to={`${url}/${itemId}`} activeClassName="active-item" onClick={onClick}>
            <ItemIconWrapper isMaster={isMaster}>{icon}</ItemIconWrapper>
            <ItemLabel>{label}</ItemLabel>
        </ItemNavLink>
    );
};

const ItemNavLink = styled(CustomNavLink)`
    display: flex;
    align-items: center;
    padding: 6px 10px;
    flex-grow: 1;
    overflow: hidden;

    &:focus {
        outline: none;
    }
`;

const ItemLabel = styled.p`
    margin-left: var(--chakra-space-2);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--chakra-colors-gray-900);
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
`;

const ItemIconWrapper = styled.div`
    svg {
        font-size: 24px;
        width: 1em;
        height: 1em;
        line-height: 1em;
        flex-shrink: 0;
        color: ${(props) => (props.isMaster ? 'var(--chakra-colors-green-500)' : 'var(--chakra-colors-gray-600)')};
    }
`;

export default ItemLinkWrapper;
